import React from 'react';
export function AnnouncementBar() {
  return <div className="bg-celeste-light py-2 px-4 text-center" data-id="element-20">
      <p className="text-sm font-medium text-azul" data-id="element-21">
        Orientación confidencial para personas y familias · Contacto directo por
        WhatsApp o llamada
      </p>
    </div>;
}